import React, { useEffect, useState } from "react";

export default function Points({ elem }) {
    const pointsUrl = elem.dataset.url || "";
    const [data, setData] = useState();

    useEffect(() => {
        window.Dibook.user.fetchPoints().then((response) => {
            setData(response.content);
        });
    }, []);

    return (
        <a
            href={pointsUrl}
            className="header-cart-button"
            data-content={data ?? false}
            data-toggle="tooltip"
            title="Pontok"
        >
            <img src="/images/icon/new-coins-icon.svg" alt="new coins" />
        </a>
    );
}
